module.exports = require('./helpers/bundle-url').getBundleURL('kQ46M') + "logo-dark.ba5147f0.svg";